export default (path) => {
  const link = document.createElement('a');
  link.setAttribute('href', path);
  link.click();
};
